import {Injectable, OnDestroy} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, Subscription} from 'rxjs';
import { ClientService } from '../services/client/client.service';

@Injectable({
  providedIn: 'root',
})
export class ClientInterceptorService implements HttpInterceptor, OnDestroy {
  private clientToken: string;
  private subscription: Subscription;

  constructor(private clientService: ClientService) {
    this.subscription = clientService.clientTokenEvent.subscribe(clientToken => (this.clientToken = clientToken));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newReq = req;    
    if (this.clientToken) {
      newReq = req.clone({setHeaders: {Client: this.clientToken}});
    }
    return next.handle(newReq);
  }
}
